import { EVENTS } from '../../config/umamiEvents';

export { EVENTS };

export type UmamiEventData = Record<string, string | number | boolean>;

declare global {
  interface Window {
    umami?: {
      track: (eventName: string, data?: UmamiEventData) => void;
    };
  }
}

/** Records a custom Umami event when the tracker is loaded (no-op otherwise). */
export function trackEvent(eventName: string, data?: UmamiEventData): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.umami?.track(eventName, data);
}
